<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-text>
        <h4 class="black--text">Daftar Umpan Balik Kegiatan Pendampingan</h4>
        <v-divider class="my-2" />
        <base-table-header @reload="onReload">
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-google-classroom</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Kegiatan
                          </p>
                          <span class="body-1 font-weight-medium">
                            {{ $getDeepObj(item, 'psp_kp_lokakarya.m_lokakarya_kegiatan_psp.keterangan') || '' }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Sekolah </small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            {{ $getDeepObj(item, 'sekolah.nama') || '' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Pelaksanaan </small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            {{ $localDate($getDeepObj(item, 'psp_kp_lokakarya.tgl_pelaksanaan') || '') }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip
                              :color="Number($getDeepObj(item, 'is_lengkap') || 0) === 1 ? 'success' : 'warning'"
                              dark
                              small
                            >
                              {{
                                Number($getDeepObj(item, 'is_lengkap') || 0) === 1 ? 'Sudah Lengkap' : 'Belum Lengkap'
                              }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn color="primary" depressed small @click="onEdit(item)">
                              <v-icon left>mdi-eye</v-icon>
                              Lihat Detail
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
      <base-modal-full ref="modal" :useSave="false" :title="formulir.title" @save="onSave">
        <component
          ref="formulir"
          :is="formulir.form"
          :initValue="formulir.init"
          :isEdit="formulir.isEdit"
          :readOnly="formulir.readOnly"
          :detail="formulir.detail"
          :isPreview="true"
        />
      </base-modal-full>
    </v-card>
  </div>
</template>
<script>
import FormFeedback from '@views/gtk/diklat/pendampingan/formulir/Feedback';
import BaseTableHeader from '@components/base/BaseTableHeader';
import BaseListTable from '@components/base/BaseListTable';
import list from '@mixins/list';
import { mapActions } from 'vuex';
export default {
  components: { FormFeedback, BaseTableHeader, BaseListTable },
  mixins: [list],
  data() {
    return {
      formulir: {},
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions('lokakaryaFeedback', ['fetch', 'getDetail', 'update']),

    fetchData: function() {
      this.isLoading = true;
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then((resp) => {
          this.data = resp?.data || [];
          this.total = resp?.total || 0;
          this.pageTotal = resp?.last_page || 1;
          this.params.limit = resp?.per_page || this.params.limit;
          this.isLoading = false;
          resolve(true);
        });
      });
    },

    async onEdit(item) {
      const id = this.$getDeepObj(item, 'psp_kp_lokakarya_feedback_id');
      let resp = await this.getDetail({ id: id }).then(({ data }) => data);

      this.$set(this.formulir, 'form', 'FormFeedback');
      this.$set(this.formulir, 'title', 'Umpan Balik Kegiatan Pendampingan');
      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'init', null);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', resp);
      });
    },

    onSave() {
      const formulir = this.$refs.formulir.form || {};
      const id = this.formulir.id;

      this.update({ id: id, params: formulir })
        .then(() => {
          this.$success('Umpan Balik Pendampingan Berhasil di Perbarui');
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
